import React from 'react'
import "./index.scss"

export default class Footer extends React.Component {
  render() {
    return (<div className="footer">
      <footer>
        <div className="footerbody">
          <p> 123</p>
        </div>
      </footer>
    </div>)
  }
}
